import { formatProduct } from 'utils/storefront/format-resource';
import ShopifyUtil from 'utils/shopify-util';

const setProductsFromRecommendations = async (rec) => {
  const productsData = await Promise.all(
    rec.products.map(async (product) => {
      const productData = await ShopifyUtil.getProductData(product.product_id);
      return productData.product ? formatProduct(productData.product) : null;
    }),
  );
  return productsData;
};

const getRecommendedProducts = (placements) =>
  new Promise((resolve, reject) => {
    const templateName = document.querySelector('.nosto_page_type')?.textContent || null;

    window.nostojs((api) => {
      const session = api.defaultSession();
      let res;

      switch (templateName) {
        case 'front': {
          res = session.viewFrontPage();
          break;
        }
        case 'product': {
          const productId = document.querySelector('.product_id')?.textContent || null;
          res = productId ? session.viewProduct(productId) : session.viewOther();
          break;
        }
        case 'category': {
          const collectionHandle = document.querySelector('.category_string')?.textContent || null;
          res = collectionHandle ? session.viewCategory(`/${collectionHandle}`) : session.viewOther();
          break;
        }
        case 'notfound': {
          res = session.viewNotFound();
          break;
        }
        default: {
          res = session.viewOther();
        }
      }

      res
        .setPlacements(placements)
        .update()
        .then(async (response) => {
          if (Object.keys(response.recommendations).length === 0) {
            console.warn('No recommendations found. Check placement ID');
            resolve({ recommendations: {}, products: {} });
            return;
          }

          const productRecommendations = response.recommendations;
          const productPromises = Object.values(productRecommendations).map(async (rec) => {
            const productsData = await setProductsFromRecommendations(rec);
            return { resultId: rec.result_id, productsData };
          });

          const updatedProductsArray = await Promise.all(productPromises);
          const updatedProducts = updatedProductsArray.reduce((acc, { resultId, productsData }) => {
            acc[resultId] = productsData.filter((data) => Boolean(data));
            return acc;
          }, {});

          resolve({ recommendations: productRecommendations, products: updatedProducts });
        })
        .catch((error) => {
          reject(error);
        });
    });
  });

export default getRecommendedProducts;
